import type { AsyncFilterConfig, FilterConfig, FilterValue, SyncFilterConfig } from './types';

export const isSyncFilterConfig = <TValue extends FilterValue = FilterValue>(
  filterConfig: FilterConfig<TValue>,
): filterConfig is SyncFilterConfig<TValue> => 'syncDeserialize' in filterConfig;

export const isAsyncFilterConfig = <TValue extends FilterValue = FilterValue>(
  filterConfig: FilterConfig<TValue>,
): filterConfig is AsyncFilterConfig<TValue> => 'asyncDeserialize' in filterConfig;
